import { Screen } from './api/types';

class SyosScreenButton {
  $el?: HTMLButtonElement;

  screen: Screen;

  onClick?: () => void;

  constructor($el: HTMLButtonElement, screen: Screen, onClick: { (): void }) {
    this.$el = $el;
    this.screen = screen;

    this.onClick = onClick;

    this.$el.addEventListener('click', onClick);
  }

  focus() {
    this.$el?.focus();
  }

  destroy() {
    this.$el?.removeEventListener('click', this.onClick!);

    this.$el = undefined;

    this.onClick = undefined;
  }
}

export default SyosScreenButton;
